import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

const SNOOZE_OPTIONS = [
  { key: '1h', label: '1 hour' },
  { key: '4h', label: '4 hours' },
  { key: 'tomorrow', label: 'Tomorrow morning', sub: '8:00 am' },
  { key: 'nextweek', label: 'Next week', sub: '8:00 am' },
];

export function snoozeUntil(key) {
  const now = new Date();
  if (key === '1h') return new Date(now.getTime() + 60 * 60 * 1000).toISOString();
  if (key === '4h') return new Date(now.getTime() + 4 * 60 * 60 * 1000).toISOString();
  if (key === 'tomorrow') {
    const t = new Date(now);
    t.setDate(t.getDate() + 1);
    t.setHours(8, 0, 0, 0);
    return t.toISOString();
  }
  if (key === 'nextweek') {
    const t = new Date(now);
    t.setDate(t.getDate() + 7);
    t.setHours(8, 0, 0, 0);
    return t.toISOString();
  }
  return null;
}

export default function SnoozeSheet({ onSnooze, onClose, anchorRef }) {
  useEffect(() => {
    function handleKey(e) { if (e.key === 'Escape') onClose(); }
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const panelRef = useRef(null);
  const [openUpward, setOpenUpward] = useState(null);

  const anchorRect = anchorRef?.current?.getBoundingClientRect();

  useLayoutEffect(() => {
    if (!anchorRect || !panelRef.current) return;
    const panelHeight = panelRef.current.offsetHeight;
    const spaceBelow = window.innerHeight - anchorRect.bottom;
    const spaceAbove = anchorRect.top;
    setOpenUpward(spaceBelow < panelHeight + 6 && spaceAbove > spaceBelow);
  });

  const panelStyle = anchorRect
    ? {
        position: 'fixed',
        ...(openUpward
          ? { bottom: window.innerHeight - anchorRect.top + 6 }
          : { top: anchorRect.bottom + 6 }),
        left: Math.max(8, anchorRect.right - 220),
        width: 220,
        zIndex: 1101,
        background: '#fff',
        borderRadius: 10,
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        overflow: 'hidden',
        visibility: openUpward === null ? 'hidden' : 'visible',
      }
    : {
        position: 'fixed', bottom: 0, left: 0, right: 0,
        zIndex: 1101,
        background: '#fff',
        borderRadius: '16px 16px 0 0',
        paddingBottom: 'env(safe-area-inset-bottom, 16px)',
        boxShadow: '0 -4px 24px rgba(0,0,0,0.12)',
      };

  return ReactDOM.createPortal(
    <>
      <div
        onClick={onClose}
        style={{
          position: 'fixed', inset: 0, zIndex: 1100,
          background: anchorRect ? 'transparent' : 'rgba(0,0,0,0.35)',
        }}
      />
      <div
        ref={panelRef}
        style={panelStyle}
        onClick={e => e.stopPropagation()}
        onMouseDown={e => e.stopPropagation()}
      >
        {!anchorRect && (
          <div style={{
            width: 36, height: 4, background: '#E0E0E0',
            borderRadius: 2, margin: '10px auto 14px',
          }} />
        )}
        <div style={{
          fontSize: 12, color: '#999', fontWeight: 500,
          padding: anchorRect ? '10px 14px 6px' : '0 20px 8px',
        }}>Snooze until</div>
        {SNOOZE_OPTIONS.map((opt, i) => (
          <button
            key={opt.key}
            onClick={() => onSnooze(opt.key)}
            style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              width: '100%', padding: anchorRect ? '10px 14px' : '14px 20px',
              borderBottom: i < SNOOZE_OPTIONS.length - 1 ? '0.5px solid #F0F0F0' : 'none',
              background: 'none', border: 'none',
              cursor: 'pointer', textAlign: 'left',
            }}
          >
            <span style={{ fontSize: anchorRect ? 13 : 14, color: '#1a1a1a' }}>{opt.label}</span>
            {opt.sub && <span style={{ fontSize: 11, color: '#999' }}>{opt.sub}</span>}
          </button>
        ))}
      </div>
    </>,
    document.body
  );
}